import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheGet, cacheSet } from 'utils/memoryCache'

const TAGS_CACHE_KEY = 'processes:tags:catalog'

const normalizeLabel = (label) => String(label || '').trim().toLowerCase()

export const getCachedTagCatalog = () => {
  const cached = cacheGet(TAGS_CACHE_KEY)
  return Array.isArray(cached) ? cached : []
}

export const setCachedTagCatalog = (catalog = []) => {
  cacheSet(TAGS_CACHE_KEY, Array.isArray(catalog) ? catalog : [])
}

export const buildTagCatalogFromProcesses = (processes = []) => {
  const map = new Map()
  processes.forEach((process) => {
    ;(process?.tags || []).forEach((tag) => {
      const key = normalizeLabel(tag?.label)
      if (key && !map.has(key)) {
        map.set(key, tag)
      }
    })
  })
  return Array.from(map.values())
}

export const upsertTagInCatalogCache = (tag) => {
  if (!tag?.label) return
  const current = getCachedTagCatalog()
  const map = new Map(current.map((item) => [normalizeLabel(item?.label), item]))
  map.set(normalizeLabel(tag.label), tag)
  setCachedTagCatalog(Array.from(map.values()))
}

export const removeTagFromCatalogCache = (label) => {
  const keyToRemove = normalizeLabel(label)
  if (!keyToRemove) return
  const next = getCachedTagCatalog().filter((item) => normalizeLabel(item?.label) !== keyToRemove)
  setCachedTagCatalog(next)
}

// Adicionar uma nova tag a um processo
export const addProcessTag = async (processId, label, color) => {
  try {
    const headers = { headers: getAuthHeaders() }
    const response = await processClient.post(`/${processId}/tags`, { label, color }, headers)
    const responseTag = response?.data?.tag || response?.data?.data?.tag
    upsertTagInCatalogCache(responseTag || { label, color })
    return response.data
  } catch (error) {
    console.error('Erro ao adicionar etiqueta:', error)
    throw error
  }
}

export const getProcessTagCatalog = async () => {
  const response = await processClient.get('/tags/catalog', { headers: getAuthHeaders() })
  const tags = response?.data?.tags || []
  tags.forEach(upsertTagInCatalogCache)
  return tags
}

// Remover uma tag de um processo
export const removeProcessTag = async (processId, tagId) => {
  try {
    const headers = { headers: getAuthHeaders() }
    const response = await processClient.delete(`/${processId}/tags/${tagId}`, headers)
    const removedLabel = response?.data?.removedTag?.label
    if (removedLabel) {
      removeTagFromCatalogCache(removedLabel)
    }
    return response.data
  } catch (error) {
    console.error('Erro ao remover etiqueta:', error)
    throw error
  }
}
